// lbl.home
export const home = {
    title: "Hello World!",
    redeemable: "Redeemable remains x{0}",
};
